import { createContext } from 'react';

import trackView from './helpers/trackView';
import trackEvent from './helpers/trackEvent';

export interface TrackingContextProps {
  trackView: (evt: any) => void;
  trackEvent: (evt: any) => void;
}

const TaggingContext = createContext<TrackingContextProps>({
  trackView,
  trackEvent,
});

/**
 * Export Provider & Consumer
 */

export const { Provider, Consumer } = TaggingContext;

/**
 * Export context
 */
export default TaggingContext;
